$(() => {
  $(document).ready(function () {
    const $btn = $("button.redirect_to_path");
    if ($btn.length > 0) {
      $btn.on("keyup keypress click", function (ev) {
        ev.preventDefault();
        $(this).prop("disabled", true);
        $(this).html("Please wait...");
        window.location.href = $(this).data("path");
      });
    }
  });
});
